import Glide from "@glidejs/glide"

import { Controller } from "stimulus"

// Banner-Sequenz auf jobs/show: ein Banner pro Slide, automatisch weiterlaufend.
export default class extends Controller {
  glide: any = null

  connect() {
    const slides = this.element.querySelectorAll(".glide__slide")
    if (slides.length < 2) return

    const glide = new Glide(this.element as any, {
      type: "carousel",
      autoplay: 5000,
      hoverpause: true,
      perView: 1,
      startAt: 0,
      animationDuration: 600,
    })
    glide.mount({})
    this.glide = glide
  }

  disconnect() {
    if (this.glide)
      this.glide.destroy()
  }
}
